<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import Button from 'primevue/button';
import Menu from 'primevue/menu';
import Dialog from 'primevue/dialog';
import Toast from 'primevue/toast';
import { useToast } from "primevue/usetoast";
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import { googleAuth, loadGoogleScripts, gapiInitServico, unloadGoogleScripts } from '@/utils/googleAuth';
import { criarGoogleForms } from '@/utils/criarGoogleForms';
import { criarGoogleDocs } from '@/utils/criarGoogleDocsQuestoes';
import { criarGoogleSlides } from '@/utils/criarGoogleSlidesQuestoes';
import { criarDocumentoWord } from '@/utils/criarDocumentoWord';

import { useGlobalToast } from '@/composables/useGlobalToast';
const { showToast } = useGlobalToast();

const props = defineProps({
    questoes: Array,
    titulo: String
})
const toast = useToast();
const visible = ref(false);

onMounted(() => {
    loadGoogleScripts('forms');
})

const logoImage = 'https://res.cloudinary.com/dzsqhh2hh/image/upload/v1716735676/jesiadaoylfzmbsavrqy.png';
const menu = ref();
const items = ref([
    {
        label: 'Para Word',
        icon: 'pi pi-file-export',
        command: () => {
            criarWord();
        }
    },
    {
        label: 'Para Google Forms',
        icon: 'pi pi-file-export',
        command: () => {
            criarForms();
        }
    },
    {
        label: 'Para Google Docs',
        icon: 'pi pi-file-export',
        command: () => {
            criarDocs();
        }
    },
    {
        label: 'Para Google Slides',
        icon: 'pi pi-file-export',
        command: () => {
            criarSlides();
        }
    },

]);

const toggle = (event) => {
    menu.value.toggle(event);
};




async function criarWord() {
    let result = await criarDocumentoWord(props.questoes, props.titulo, logoImage);
    if (result) {
        showToast({
            severity: 'info',
            summary: 'O documento foi criado com sucesso',
            detail: 'Veja na sua pasta de downloads',
        });
    }
}

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

async function criarForms() {
    visible.value = true
    await gapiInitServico('forms');
    await delay(2000);
    let response = await googleAuth();
    if (response) {
        let response = await criarGoogleForms(props.questoes, props.titulo);
        if (response.status == 'erro') {
            showToast({
                severity: 'error',
                summary: 'Erro ao criar o formulário',
                detail: response.erro
            })
            visible.value = false
            return
        }else{
            showToast({
                severity: 'info',
                summary: 'O formulário foi criado com sucesso',
                detail: 'Veja nos arquivos recentes do seu Google Drive',
            })
        }
        console.log(`https://docs.google.com/forms/d/${response.formId}/edit`);
        window.open(`https://docs.google.com/forms/d/${response.formId}/edit`, '_blank')
    }
    visible.value = false
}

async function criarDocs() {
    visible.value = true
    await gapiInitServico('docs');
    await delay(2000);
    let response = await googleAuth();
    if (response) {
        let result = await criarGoogleDocs(props.questoes, props.titulo);
        if (result.status == 'erro') {
            showToast({
                severity: 'error',
                summary: 'Erro ao criar o documento',
                detail: result.erro
            })
            visible.value = false
            return
        }else{
            showToast({
                severity: 'info',
                summary: 'O documento foi criado com sucesso',
                detail: 'Veja nos arquivos recentes do seu Google Drive',
            })
        }
        console.log(`https://docs.google.com/document/d/${result.docId}/edit`);
        window.open(`https://docs.google.com/document/d/${result.docId}/edit`, '_blank')
    }
    visible.value = false
}

async function criarSlides() {
    visible.value = true
    await gapiInitServico('slides');
    await delay(2000);
    let response = await googleAuth();
    if (response) {
        let result = await criarGoogleSlides(props.questoes, props.titulo);
        if (result.status == 'erro') {
            showToast({
                severity: 'error',
                summary: 'Erro ao criar o slide',
                detail: result.erro
            })
            visible.value = false
            return
        }else{
            showToast({
                severity: 'info',
                summary: 'O slide foi criado com sucesso',
                detail: 'Veja nos arquivos recentes do seu Google Drive',
            })
        }
        console.log(`https://docs.google.com/presentation/d/${result.slideId}/edit`);
        window.open(`https://docs.google.com/presentation/d/${result.slideId}/edit`, '_blank')
        visible.value = false
    }
}



</script>


<template>
    <Button type="button" icon="pi pi-file-export" label="Exportar" @click="toggle" aria-haspopup="true"
        aria-controls="overlay_menu" text severity="secondary" />
    <Menu ref="menu" id="overlay_menu" :model="items" :popup="true" />
    <Dialog v-model:visible="visible" modal :style="{ width: '25rem' }" :closable="false">
        <div class="text-center mb-4">Estamos criando seu arquivo.</div>
        <LoadingSpinner />
    </Dialog>
</template>